class Header {
    constructor() {
        this.header = document.querySelector('.js-header');

        if (this.header) {
            this.changeHeaderStyle();
            this.initEvent();
        }
    }

    initEvent() {
        window.addEventListener('scroll', () => { this.changeHeaderStyle(); });
    }

    changeHeaderStyle() {
        if (window.pageYOffset > 200) {
            this.header.classList.add('header--fixed');
        } else {
            this.header.classList.remove('header--fixed');
        }
    }
}

const header = {
    init() {
        return new Header();
    },
};

export default header;
